// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"0e989578","133":"966adbec","504":"8e79184c","770":"d4e3b98b","881":"a39c434f","923":"a03025cd"}[chunkId] + ".chunk.css";
};